<template>
  <div class="ui-block">
    <article class="hentry post">
      <div class="ui-block-title">
        <div v-if="categories && categories.length ">
          <div
            v-for="cat in categories"
            :key="cat.id"
            style="color: #fff; padding: 15px; margin-bottom: 5px; display: inline-block; font-size: 10px; font-weight: bold; margin-right: 5px;"
            :style="{backgroundColor: cat.color}"
          >
            {{ cat.name }}
          </div>
        </div>
        <add-financial-row />
        <div class="control-block-button">
          <a
            href="#"
            class="btn btn-control bg-breez"
            @click="$modal.show('create-financial-row', {item: {cat_id: '', date: date1 }})"
          >
            <app-icon
              name="olymp-plus-icon"
              color="white"
              size="normal"
            />
          </a>
        </div>
      </div>


      <!-- Order Totals List-->

      <div
        style="padding: 20px 20px 10px 15px;"
        class="crumina-module crumina-heading with-title-decoration"
      >
        <h3 style="border-bottom: 3px solid #ff5e3a">
          Cheltuieli
        </h3>
      </div>
      <br>
      <br>
      <table
        v-if="items && items.length"
        style="width:100%"
        class="shop_table cart"
      >
        <thead>
          <tr>
            <th class="product-date">
              DATE
            </th>
            <th class="product-description">
              ITEM DESCRIPTION
            </th>
            <th class="product-price">
              PRICE
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item.id"
            class="cart_item"
          >
            <td
              class="product-date"
              style="min-width: 90px;"
            >
              <span>{{ Object.keys(item)[0] }}</span>
            </td>
            <td class="product-description">
              <div
                v-for="message in item[Object.keys(item)[0]]"
                :key="message.id"
                class="cart-product-content"
                style="padding-right: 10px;"
              >
                <h6 class="cart-product-title">
                  <div
                    style="width: 10px; height:10px; display: inline-block; margin-right: 5px;"
                    :style="{ 'background-color': message.FiCat.color }"
                  />{{ message.description }}
                </h6><br>
              </div>
            </td>
            <td
              class="product-price"
              style="min-width: 100px"
            >
              <div
                v-for="message in item[Object.keys(item)[0]]"
                :key="message.id"
              >
                <h6 class="price amount">
                  {{ message.price }} RON
                </h6>
                <a
                  href="#"
                  style="margin-left: 15px;"
                  @click="$modal.show('create-financial-row', { item: message })"
                >
                  <app-icon
                    name="olymp-three-dots-icon"
                    color="gray"
                    size="normal"
                  />
                </a>
                <br>
              </div>
            </td>
          </tr>
          <tr>
            <td
              colspan="3"
              class="actions"
            >
              <div
                style="font-size: 16px;"
                class="cart-subtotal"
              >
                Personal Subtotal:<span class="total-personal">{{ subtotal_personal.toLocaleString() }} RON</span>
              </div>
            </td>
          </tr>
          <tr>
            <td
              colspan="3"
              class="actions"
            >
              <div
                style="font-size: 16px;"
                class="cart-subtotal"
              >
                Business Subtotal:<span class="total-business">{{ subtotal_business.toLocaleString() }} RON</span>
              </div>
            </td>
          </tr>
          <tr>
            <td
              colspan="3"
              class="actions"
            >
              <div
                style="font-size: 24px;"
                class="cart-subtotal"
              >
                Total:<span class="total">{{ (subtotal_personal + subtotal_business).toLocaleString() }} RON</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <br><br>
      <div class="row">
        <div
          v-if="itemsRec"
          style="padding: 20px 20px 10px 15px;"
          class="crumina-module crumina-heading with-title-decoration"
        >
          <h3 style="border-bottom: 3px solid #ff5e3a">
            Plati Recurente
          </h3>
        </div>
        <div
          v-for="(item, key) in itemsRec"
          :key="key"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
        >
          <div style="border-bottom: 1px solid #dce1eb;">
            <h6 class="title">
              {{ key | getRecurrentName(recurrencyTypes) }}
            </h6>
          </div>

          <div
            class="row"
            style="margin-top: 15px; margin-bottom: 10px;"
          >
            <div
              v-for="(item1,key1) in itemsRec[key]"
              :key="key1"
              class="col col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12"
            >
              <div class="">
                <div class="available-widget">
                  <div class="checkbox">
                    <label>
                      <input
                        name="optionsCheckboxes"
                        type="checkbox"
                        :checked="item1.checked"
                        disabled
                      ><span class="checkbox-material"><span class="check" /></span>
                      {{ item1.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AddFinancialRow from './AddFinancialRow'
import AppIcon from "../../common-apps/common/AppIcon"
import financialStore from '../../../store/modules/personal/financial'

export default {
  name: 'FinancialTable',
  components: { AddFinancialRow, AppIcon },
  props: {
    date: {
      type: Date,
      default: function () { return {} }
    }
  },
  data () {
    return {
      date1: new Date()
    }
  },
  computed: mapState({
    items: state => state.financial ?  state.financial.items : [],
    recurrent: state => state.financial ? state.financial.recurrent : [],
    subtotal_personal: state => state.financial ? state.financial.subtotal_personal : 0,
    subtotal_business: state => state.financial ? state.financial.subtotal_business : 0,
    categories: state => state.financial ? state.financial.categories : [],
    itemsRec: state => state.financial ? state.financial.itemsRec : [],
  }),
  created () {
    if (!this.$store.hasModule('financial')) {
      this.$store.registerModule('financial', financialStore)
    }
    this.$store.dispatch('financial/getCat')
  },
  activated () {
    this.$store.dispatch('financial/getCurrentMonth', { date: this.date })
  },
  beforeDestroy () {
    this.$store.unregisterModule('financial')
  },
  methods: {}
}
</script>
